// "The picture changed" - for the viewer's idle render skip.
//
// The render loop stops drawing when nothing moved (viewer/renderOnDemand).
// Camera motion and input it sees for itself; a change made to the scene
// from code - a pool flushed at rest, an element hidden, tinted or
// ghosted by a panel - it cannot, so the places that make those changes
// bump this counter and the next frame draws. Anything that forgets is
// still drawn by the idle safety frame, just up to half a second late.
let version = 0;

// Who asked, counted per call site, so "the view keeps redrawing with the
// camera still" can be answered from perfSnapshot().sceneBumps instead of
// guessed (2026-10-13). A string key and an increment: nothing allocates.
const bumps = {};
export function markSceneChanged(source = 'other') { version += 1; bumps[source] = (bumps[source] || 0) + 1; }
export function sceneBumps() { return { ...bumps }; }
export function sceneVersion() { return version; }
